import React, { Component } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';

class OrderListView extends Component {
    render() {
        const columns = [{
            title: 'Order #',
            dataIndex: 'key',
            key: 'key',
            render: (order_num) => <Link to={`order/${order_num}`}>{order_num}</Link>
        }, {
            title: 'Cliente',
            dataIndex: 'client',
            key: 'client',
        }, {
            title: 'Fecha',
            dataIndex: 'date',
            key: 'date',
            render: (date) => (new Date(date)).toString()
        }, {
            title: 'Peso',
            dataIndex: 'weight',
            key: 'weight',
            render: (kgs) => kgs.toFixed(4) + ' kgs'
        }, {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            render: (total) => '€ ' + total
        }];
        return <Table dataSource={this.props.orders} columns={columns} />
    }
}

export default OrderListView;



// WEBPACK FOOTER //
// ./src/components/views/OrderListView.jsx